import { createContext, useContext } from "react";

export type PreviewState = "idle" | "loading" | "playing" | "error";

export type VoicePreviewContextValue = {
  activeVoiceId: string | null;
  state: PreviewState;
  toggle: (voiceId: string, previewUrl: string) => Promise<void>;
};

export const VoicePreviewContext =
  createContext<VoicePreviewContextValue | null>(null);

export function useVoicePreview() {
  const value = useContext(VoicePreviewContext);
  if (!value) {
    throw new Error("useVoicePreview must be used inside VoicePreviewProvider");
  }
  return value;
}
